import { CSSResultGroup, html, LitElement } from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import { customElement, property } from 'lit/decorators.js'
import { style } from './loader.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'

export const loaderVariants = ['default', 'spinner'] as const
export type loaderVariantTypes = typeof loaderVariants

@customElement('cse-loader')
export class CSELoader extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Boolean })
  animated = true

  @property({ type: String })
  variant: loaderVariantTypes[number] = 'default'

  override render() {
    if (this.variant === 'default') {
      const classes = classMap({
        'animated': this.animated
      })
      return html`
        <div class="cse-loader" aria-live="polite" role="status">
          <div class=${classes}>
            <slot name="custom-icon">
              <cse-icon icon-role="cse-loader.spinner"></cse-icon>
            </slot>
          </div>
        </div>
      `
    } else {
      return html`
        <div class="cse-loader spinner" aria-live="polite" role="status">
          <svg width="48" height="48" viewBox="0 0 48 48">
            <circle
              class="spinner-background"
              cx="24" cy="24" r="20"
              stroke-width="6"
              fill="none"
            />
            <circle
              class="spinner-foreground"
              cx="24" cy="24" r="20"
              stroke-width="6"
              fill="none"
              stroke-linecap="round"
            />
          </svg>
        </div>
      `
    }
  }
}

initializeIconsByRole({
  'cse-loader.spinner': { name: 'spinner', style: 'solid' },
})


declare global {
  interface HTMLElementTagNameMap {
    'cse-loader': CSELoader
  }
}
